module.exports = __webpack_public_path__ + "img/DW365-281.fc3bc498.jpg";